module.exports = {"HOME":"HOME","TERUG":"TERUG","TITLE":"TFS"}


//////////////////
// WEBPACK FOOTER
// ./src/plugins/tfs/platformConfigs/staticTextMaps/menu.json
// module id = 1799
// module chunks = 1